import React from 'react';
import classnames from 'classnames';
import {NavLink, useLocation} from 'react-router-dom';
import styles from './NavItem.module.scss';

export interface NavItemProps {
  link: string
  label: React.ReactNode
  className?: string
  onClick?: () => void | Promise<void>
}

const NavItem = ({link, className, label, onClick}: NavItemProps) => {
  const location = useLocation();
  const sameLocation = location.pathname === link;

  return (
    <div className={classnames(
      styles.navItemContainer,
      {[styles.activeLink]: sameLocation},
      className
    )}>
      <NavLink
        to={link}
        onClick={async () => {
          if (onClick) {
            await onClick();
          }
        }}
        className={styles.navItem}
      >
        {label}
      </NavLink>
    </div>
  );
};

export default NavItem;
